import { motion } from "framer-motion";

// خلفية سينمائية: عمق نيلي، شبكة أثلاث، رموز عائمة، مسح AR
export default function CinematicBackground({ scanning = false, dense = false }) {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" style={{ background: "radial-gradient(120% 90% at 50% 0%, #0d1730 0%, #070b16 45%, #04060d 100%)" }}>
      {/* توهج أزرق ذكاء اصطناعي */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full" style={{ background: "radial-gradient(circle, rgba(78,168,255,0.16), transparent 70%)" }} />
      <div className="absolute bottom-0 right-0 w-[420px] h-[420px] rounded-full" style={{ background: "radial-gradient(circle, rgba(217,180,106,0.10), transparent 70%)" }} />

      {/* شبكة قاعدة الأثلاث الخافتة */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.10]" preserveAspectRatio="none">
        <line x1="33.33%" y1="0" x2="33.33%" y2="100%" stroke="#d9b46a" strokeWidth="1" />
        <line x1="66.66%" y1="0" x2="66.66%" y2="100%" stroke="#d9b46a" strokeWidth="1" />
        <line x1="0" y1="33.33%" x2="100%" y2="33.33%" stroke="#d9b46a" strokeWidth="1" />
        <line x1="0" y1="66.66%" x2="100%" y2="66.66%" stroke="#d9b46a" strokeWidth="1" />
      </svg>

      {/* رموز عائمة ISO / f / shutter */}
      {(dense ? FLOATERS_DENSE : FLOATERS).map((f, i) => (
        <motion.div
          key={i}
          className="absolute font-display text-gold/25 select-none"
          style={{ top: f.top, left: f.left, fontSize: f.size }}
          animate={{ y: [0, -16, 0], opacity: [0.15, 0.45, 0.15] }}
          transition={{ duration: 6 + i, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
        >
          {f.t}
        </motion.div>
      ))}

      {/* حلقة عدسة تدور */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[70vw] h-[70vw] max-w-[560px] max-h-[560px] rounded-full border border-ai-blue/10 spin-slow" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[46vw] h-[46vw] max-w-[380px] max-h-[380px] rounded-full border border-gold/10" />

      <div className="grain" />
      {scanning && <div className="scan-line" style={{ top: 0 }} />}
    </div>
  );
}

const FLOATERS = [
  { t: "ISO 400", top: "18%", left: "12%", size: 14 },
  { t: "f/2.8", top: "70%", left: "8%", size: 16 },
  { t: "1/50", top: "30%", left: "82%", size: 14 },
  { t: "24 FPS", top: "78%", left: "78%", size: 13 },
  { t: "◎", top: "50%", left: "6%", size: 22 },
];
const FLOATERS_DENSE = [
  ...FLOATERS,
  { t: "5600K", top: "12%", left: "60%", size: 13 },
  { t: "85mm", top: "60%", left: "44%", size: 13 },
  { t: "⌖", top: "40%", left: "90%", size: 20 },
];
